import gql from "graphql-tag";

const RESEND_PROSPECT_APPOINTMENT_CONFIRMATION = gql`
  mutation resendProspectAppointmentConfirmation($appointment_id: ID!) {
    resendProspectAppointmentConfirmation(appointment_id: $appointment_id) {
      message
      code
    }
  }
`;

export default RESEND_PROSPECT_APPOINTMENT_CONFIRMATION;
